export enum GridForm {
  DetailDrawerFormTitle = 'CyDs',
  TotalItemsCost = 'uj3k',
  DeliveryFee = 'QZ8c',
  SalesTax = 'W9cj',
  ItemList = 'aHZ0',
  ItemName = 'BtSR',
  Reason = '+Bq4',
  GLAccount = 'MA72',
  OrderingUnit = '8RvE',
  QuantityOrdered = 'lGo4',
  UnitCost = 'y4Ih',
  OrderExtendedCost = 'W5HL',
  QuantityReceived = 'jKPo',
  ReceivedUnitCost = 'hmZt',
  ReceivedExtendedCost = 'Wi1u',
  OrderDocket = 'a/AO',
  DeliveryDocket = 'ZWX4',
  ExportMajorMinorTitle = 'onB1',
  OrderedBy = 'y4IZ',
  ApprovedBy = 'joOM',
  DeliveredBy = 'zY6F',
  DeliveredByInSignature = '9rq2',
  ReceivedByInSignature = 'joB5',
  ReceivedBy = 'xaWu',
  RequestedBy = 'kZmg',
  TransferredBy = 'nZtz',
  CompletedBy = 'yZIK',
  VoidedBy = 'UW7w',
  RejectedBy = 'KtRM',
  ModifiedDate = 'XlWt',
  ID = 'OEOX',
  EntityID = 'j/wJ',
  SelectAnOption = '+xy8',
  form = 'Bzl9',
  AddToList = 'yExa',
  AddedItemsBrackets = '2Sgr',
  ItemID = 'Ll/+',
  MajorCategory = 'LDUH',
  MinorCategory = '77IH',
  EditEntity = 'L767',
  SaveAndAdd = 'UiGh',
  VendorName = 'vG51',
  VendorItemCode = 'b9Hk',
  SiteAvailability = 'B7pP',
  GridItems = '+456',
  ProductName = 'TiD6',
  ProductID = 'x2ye',
  UnitPrice = 'FPYk',

  FilteredList = 'Hli1',
  ChargeableOnly = 'YqkI',
  NonChargeableOnly = 'N10T',
  AllFilteredItems = 'kej/',
  AllItems = 'R3cw',

  AcceptingOrRejecting = 'aU0V',
  Submitting = '1N+Y',
  Accepting = 'B9hE',
  Rejecting = 'pjnY',

  UpdatedItems = '4ZiP',
  UnavailableItems = 'sfaT',

  BaseUnit = 'bCz6',

  Measure = '6/lA',
  Average = 's4ri',

  PhysicalQty = '1mMK',
  EventWithColon = 'BtkV',
  EventStartWithColon = 'xoJR',
  ChargeableWithColon = 'oJPJ',
  SiteWithColon = 'BiSb',
  EventEndWithColon = 'Ltz7',
  UnitWithColon = 'beRH',
  StatusWithColon = 'SImV',

  Threshold = 'DaYn',

  SiteNameColon = 'mV4q',
  SiteIDColon = 'dxQR',
  EventTypeColon = 'GTGO',
  SearchColon = 'M2Pl',

  FirstName = 'ls5u',
  LastName = '9VVj',
  BadgeNumber = 'YYx+',

  isExpandAllProducts = 'obfI',

  NotAssigned = 'OZbb',
}
